// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard-progress {
    display: flex;
    width: max-content;
    max-width: 100%;
    gap: 0;
    margin: 0 auto 1.5rem;
    padding: 0.75rem 0.5rem;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    border: 1px solid var(--color-border-soft, #ddd);
    border-radius: 10px;
    background: var(--color-surface, #fff);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.wizard-progress-step {
    position: relative;
    display: flex;
    flex: 0 0 5.375rem;
    flex-direction: column;
    align-items: center;
    gap: 0.35rem;
    min-width: 0;
    padding: 0.25rem 0.35rem;
    border: 0;
    background: transparent;
    color: #777;
    font: inherit;
    font-size: 0.78rem;
    line-height: 1.2;
    text-align: center;
}

.wizard-progress-step:not(:first-child)::before {
    position: absolute;
    z-index: 0;
    top: 1.2rem;
    right: 50%;
    width: 100%;
    height: 2px;
    background: var(--color-border-soft, #ddd);
    content: '';
}

.wizard-progress-step.done + .wizard-progress-step::before {
    background: #4f8543;
}

.wizard-progress-step.current {
    color: var(--color-text, #222);
    font-weight: 700;
}

.wizard-progress-step.done {
    color: #3f7135;
    font-weight: 600;
}

.wizard-progress-step.clickable {
    cursor: pointer;
}

.wizard-progress-step.clickable:hover {
    color: #284b22;
}

.wizard-progress-step:focus-visible {
    outline: 2px solid #4f8543;
    outline-offset: 2px;
}

.wizard-progress-dot {
    position: relative;
    z-index: 1;
    display: inline-flex;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    border: 2px solid var(--color-border-soft, #ddd);
    border-radius: 50%;
    background: var(--color-surface, #fff);
    color: #777;
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1;
}

.wizard-progress-step.done .wizard-progress-dot {
    border-color: #4f8543;
    background: #4f8543;
    color: #fff;
}

.wizard-progress-step.current .wizard-progress-dot,
.wizard-progress-step.current.done .wizard-progress-dot {
    border-color: #1f2924;
    background: #1f2924;
    color: #fff;
    box-shadow: 0 0 0 3px rgba(79, 133, 67, 0.18);
}

.wizard-progress-step:disabled {
    cursor: default;
    opacity: 1;
}

[data-theme="dark"] .wizard-progress {
    border-color: #3a463e;
    background: #1c2620;
    box-shadow: none;
}

[data-theme="dark"] .wizard-progress-step {
    color: #9fb0a6;
}

[data-theme="dark"] .wizard-progress-step:not(:first-child)::before {
    background: #3a463e;
}

[data-theme="dark"] .wizard-progress-step.done + .wizard-progress-step::before,
[data-theme="dark"] .wizard-progress-step.done .wizard-progress-dot {
    border-color: #67a45a;
    background: #67a45a;
}

[data-theme="dark"] .wizard-progress-step.done {
    color: #9bd18f;
}

[data-theme="dark"] .wizard-progress-step.current {
    color: #e3ece6;
}

[data-theme="dark"] .wizard-progress-step.current .wizard-progress-dot,
[data-theme="dark"] .wizard-progress-step.current.done .wizard-progress-dot {
    border-color: #e3ece6;
    background: #e3ece6;
    color: #14201a;
}

@media (max-width: 600px) {
    .wizard-progress {
        width: 100%;
        margin-bottom: 1rem;
        padding-right: 0.25rem;
        padding-left: 0.25rem;
        border-radius: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/WizardProgress.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,mCAAmC;IACnC,gDAAgD;IAChD,mBAAmB;IACnB,sCAAsC;IACtC,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gDAAgD;IAChD,kBAAkB;IAClB,sCAAsC;IACtC,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;QACnB,sBAAsB;QACtB,qBAAqB;QACrB,kBAAkB;IACtB;AACJ","sourcesContent":[".wizard-progress {\n    display: flex;\n    width: max-content;\n    max-width: 100%;\n    gap: 0;\n    margin: 0 auto 1.5rem;\n    padding: 0.75rem 0.5rem;\n    overflow-x: auto;\n    overscroll-behavior-inline: contain;\n    border: 1px solid var(--color-border-soft, #ddd);\n    border-radius: 10px;\n    background: var(--color-surface, #fff);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.wizard-progress-step {\n    position: relative;\n    display: flex;\n    flex: 0 0 5.375rem;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.35rem;\n    min-width: 0;\n    padding: 0.25rem 0.35rem;\n    border: 0;\n    background: transparent;\n    color: #777;\n    font: inherit;\n    font-size: 0.78rem;\n    line-height: 1.2;\n    text-align: center;\n}\n\n.wizard-progress-step:not(:first-child)::before {\n    position: absolute;\n    z-index: 0;\n    top: 1.2rem;\n    right: 50%;\n    width: 100%;\n    height: 2px;\n    background: var(--color-border-soft, #ddd);\n    content: '';\n}\n\n.wizard-progress-step.done + .wizard-progress-step::before {\n    background: #4f8543;\n}\n\n.wizard-progress-step.current {\n    color: var(--color-text, #222);\n    font-weight: 700;\n}\n\n.wizard-progress-step.done {\n    color: #3f7135;\n    font-weight: 600;\n}\n\n.wizard-progress-step.clickable {\n    cursor: pointer;\n}\n\n.wizard-progress-step.clickable:hover {\n    color: #284b22;\n}\n\n.wizard-progress-step:focus-visible {\n    outline: 2px solid #4f8543;\n    outline-offset: 2px;\n}\n\n.wizard-progress-dot {\n    position: relative;\n    z-index: 1;\n    display: inline-flex;\n    width: 32px;\n    height: 32px;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid var(--color-border-soft, #ddd);\n    border-radius: 50%;\n    background: var(--color-surface, #fff);\n    color: #777;\n    font-size: 0.82rem;\n    font-weight: 700;\n    line-height: 1;\n}\n\n.wizard-progress-step.done .wizard-progress-dot {\n    border-color: #4f8543;\n    background: #4f8543;\n    color: #fff;\n}\n\n.wizard-progress-step.current .wizard-progress-dot,\n.wizard-progress-step.current.done .wizard-progress-dot {\n    border-color: #1f2924;\n    background: #1f2924;\n    color: #fff;\n    box-shadow: 0 0 0 3px rgba(79, 133, 67, 0.18);\n}\n\n.wizard-progress-step:disabled {\n    cursor: default;\n    opacity: 1;\n}\n\n[data-theme=\"dark\"] .wizard-progress {\n    border-color: #3a463e;\n    background: #1c2620;\n    box-shadow: none;\n}\n\n[data-theme=\"dark\"] .wizard-progress-step {\n    color: #9fb0a6;\n}\n\n[data-theme=\"dark\"] .wizard-progress-step:not(:first-child)::before {\n    background: #3a463e;\n}\n\n[data-theme=\"dark\"] .wizard-progress-step.done + .wizard-progress-step::before,\n[data-theme=\"dark\"] .wizard-progress-step.done .wizard-progress-dot {\n    border-color: #67a45a;\n    background: #67a45a;\n}\n\n[data-theme=\"dark\"] .wizard-progress-step.done {\n    color: #9bd18f;\n}\n\n[data-theme=\"dark\"] .wizard-progress-step.current {\n    color: #e3ece6;\n}\n\n[data-theme=\"dark\"] .wizard-progress-step.current .wizard-progress-dot,\n[data-theme=\"dark\"] .wizard-progress-step.current.done .wizard-progress-dot {\n    border-color: #e3ece6;\n    background: #e3ece6;\n    color: #14201a;\n}\n\n@media (max-width: 600px) {\n    .wizard-progress {\n        width: 100%;\n        margin-bottom: 1rem;\n        padding-right: 0.25rem;\n        padding-left: 0.25rem;\n        border-radius: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
